const translation = {
  currentPlan: 'Plan Actual',
  upgradeBtn: {
    plain: 'Actualizar Plan',
    encourage: 'Actualizar Ahora',
    encourageShort: 'Actualizar',
  },
  viewBilling: 'Administrar facturación y suscripciones',
  buyPermissionDeniedTip: 'Por favor, contacta al administrador de tu empresa para suscribirte',
  plansCommon: {
    title: 'Elige un plan que sea adecuado para ti',
    yearlyTip: '¡Obtén 2 meses gratis al suscribirte anualmente!',
    mostPopular: 'Más Popular',
    planRange: {
      monthly: 'Mensual',
      yearly: 'Anual',
    },
    month: 'mes',
    year: 'año',
    save: 'Ahorra ',
    free: 'Gratis',
    currentPlan: 'Plan Actual',
    contractSales: 'Contactar ventas',
    contractOwner: 'Contactar al administrador del equipo',
    startForFree: 'Empezar gratis',
    getStartedWith: 'Empezar con ',
    contactSales: 'Contactar Ventas',
    talkToSales: 'Hablar con Ventas',
    modelProviders: 'Proveedores de Modelos',
    teamMembers: 'Miembros del Equipo',
    annotationQuota: 'Cuota de Anotación',
    buildApps: 'Crear Aplicaciones',
    vectorSpace: 'Espacio Vectorial',
    vectorSpaceBillingTooltip: 'Cada 1MB puede almacenar aproximadamente 1.2 millones de caracteres de datos vectorizados (estimado utilizando OpenAI Embeddings, varía según los modelos).',
    vectorSpaceTooltip: 'El Espacio Vectorial es el sistema de memoria a largo plazo necesario para que los LLMs comprendan tus datos.',
    documentsUploadQuota: 'Cuota de Carga de Documentos',
    documentProcessingPriority: 'Prioridad de Procesamiento de Documentos',
    documentProcessingPriorityTip: 'Para una mayor prioridad de procesamiento de documentos, por favor actualiza tu plan.',
    documentProcessingPriorityUpgrade: 'Procesa más datos con mayor precisión y velocidad.',
    priority: {
      'standard': 'Estándar',
      'priority': 'Prioridad',
      'top-priority': 'Prioridad Máxima',
    },
    logsHistory: 'Historial de Registros',
    customTools: 'Herramientas Personalizadas',
    unavailable: 'No disponible',
    days: 'días',
    unlimited: 'Ilimitado',
    support: 'Soporte',
    supportItems: {
      communityForums: 'Foros Comunitarios',
      emailSupport: 'Soporte por Correo Electrónico',
      priorityEmail: 'Soporte Prioritario por Correo Electrónico y Chat',
      logoChange: 'Cambio de Logotipo',
      SSOAuthentication: 'Autenticación SSO',
      personalizedSupport: 'Soporte Personalizado',
      dedicatedAPISupport: 'Soporte API Dedicado',
      customIntegration: 'Integración y Soporte Personalizado',
      ragAPIRequest: 'Solicitudes API RAG',
      bulkUpload: 'Carga Masiva de Documentos',
      agentMode: 'Modo Agente',
      workflow: 'Flujo de Trabajo',
      llmLoadingBalancing: 'Balanceo de Carga LLM',
      llmLoadingBalancingTooltip: 'Agrega múltiples claves API a los modelos, evitando efectivamente los límites de velocidad de API.',
    },
    comingSoon: 'Próximamente',
    member: 'Miembro',
    memberAfter: 'Miembro',
    messageRequest: {
      title: 'Créditos de Mensajes',
      tooltip: 'Cuotas de invocación de mensajes para varios planes utilizando modelos de OpenAI (excepto gpt4). Los mensajes que excedan el límite utilizarán tu clave API de OpenAI.',
      titlePerMonth: '{{count,number}} mensajes/mes',
    },
    annotatedResponse: {
      title: 'Límites de Cuota de Anotación',
      tooltip: 'Edición manual y anotación de respuestas proporciona habilidades de respuesta a preguntas personalizadas y de alta calidad para aplicaciones (aplicable solo en aplicaciones de chat).',
    },
    ragAPIRequestTooltip: 'Se refiere al número de llamadas API que invocan solo las capacidades de procesamiento de base de conocimientos de Dify.',
    receiptInfo: 'Solo el propietario del equipo y el administrador del equipo pueden suscribirse y ver la información de facturación.',
    priceTip: 'por espacio de trabajo/',
    teamMember_one: '{{count, número}} Miembro del Equipo',
    getStarted: 'Comenzar',
    apiRateLimitUnit: '{{count, número}}/día',
    freeTrialTipSuffix: 'No se requiere tarjeta de crédito',
    unlimitedApiRate: 'Sin límite de tasa de API',
    apiRateLimit: 'Límite de tasa de API',
    documentsTooltip: 'Cuota sobre el número de documentos importados desde la Fuente de Datos del Conocimiento.',
    comparePlanAndFeatures: 'Compara planes y características',
    cloud: 'Servicio en la nube',
    teamMember_other: '{{count,number}} Miembros del equipo',
    annualBilling: 'Facturación Anual',
    self: 'Autoalojado',
    freeTrialTip: 'prueba gratuita de 200 llamadas de OpenAI.',
    teamWorkspace: '{{count,number}} Espacio de Trabajo en Equipo',
    documents: '{{count,number}} Documentos de Conocimiento',
    documentsRequestQuota: '{{count,number}}/min Límite de tasa de solicitud de conocimiento',
    freeTrialTipPrefix: 'Regístrate y obtén un',
    apiRateLimitTooltip: 'El límite de tasa de la API se aplica a todas las solicitudes realizadas a través de la API de Dify, incluidos la generación de texto, las conversaciones de chat, las ejecuciones de flujo de trabajo y el procesamiento de documentos.',
    documentsRequestQuotaTooltip: 'Especifica el número total de acciones que un espacio de trabajo puede realizar por minuto dentro de la base de conocimientos, incluyendo la creación, eliminación, actualización de conjuntos de datos, carga de documentos, modificaciones, archivo y consultas a la base de conocimientos. Esta métrica se utiliza para evaluar el rendimiento de las solicitudes a la base de conocimientos. Por ejemplo, si un usuario de Sandbox realiza 10 pruebas consecutivas en un minuto, su espacio de trabajo será temporalmente restringido de realizar las siguientes acciones durante el siguiente minuto: creación de conjuntos de datos, eliminación, actualizaciones y carga o modificaciones de documentos.',
  },
  plans: {
    sandbox: {
      name: 'Sandbox',
      description: 'Prueba gratuita de 200 veces GPT',
      includesTitle: 'Incluye:',
      for: 'Prueba gratuita de capacidades básicas',
    },
    professional: {
      name: 'Profesional',
      description: 'Para individuos y pequeños equipos que desean desbloquear más poder de manera asequible.',
      includesTitle: 'Todo en el plan gratuito, más:',
      for: 'Para desarrolladores independientes/equipos pequeños',
    },
    team: {
      name: 'Equipo',
      description: 'Colabora sin límites y disfruta de un rendimiento de primera categoría.',
      includesTitle: 'Todo en el plan Profesional, más:',
      for: 'Para equipos de tamaño mediano',
    },
    enterprise: {
      name: 'Empresa',
      description: 'Obtén capacidades completas y soporte para sistemas críticos a gran escala.',
      includesTitle: 'Todo en el plan Equipo, más:',
      features: {
        0: 'Soluciones de implementación escalables de nivel empresarial',
        7: 'Actualizaciones y Mantenimiento por Dify Oficialmente',
        8: 'Soporte Técnico Profesional',
        3: 'Múltiples Espacios de Trabajo y Gestión Empresarial',
        1: 'Autorización de Licencia Comercial',
        2: 'Características Exclusivas de la Empresa',
        5: 'SLA negociados por Dify Partners',
        4: 'SSO',
        6: 'Seguridad y Controles Avanzados',
      },
      btnText: 'Contactar ventas',
      for: 'Para equipos de gran tamaño',
      price: 'Personalizado',
      priceTip: 'Facturación Anual Solo',
    },
    community: {
      features: {
        0: 'Todas las características principales se lanzaron bajo el repositorio público',
        2: 'Cumple con la Licencia de Código Abierto de Dify',
        1: 'Espacio de trabajo único',
      },
      includesTitle: 'Características gratuitas:',
      for: 'Para usuarios individuales, pequeños equipos o proyectos no comerciales',
      price: 'Gratis',
      btnText: 'Comienza con la Comunidad',
      name: 'Comunidad',
      description: 'Para usuarios individuales, pequeños equipos o proyectos no comerciales',
    },
    premium: {
      features: {
        0: 'Confiabilidad autogestionada por varios proveedores de nube',
        1: 'Espacio de trabajo único',
        3: 'Soporte prioritario por correo electrónico y chat',
        2: 'Personalización de logotipos y marcas de WebApp',
      },
      description: 'Para organizaciones y equipos de tamaño mediano',
      comingSoon: 'Soporte de Microsoft Azure y Google Cloud disponible próximamente',
      btnText: 'Obtén Premium en',
      priceTip: 'Basado en el Mercado de la Nube',
      price: 'Escalable',
      includesTitle: 'Todo de Community, además:',
      name: 'Premium',
      for: 'Para organizaciones y equipos de tamaño mediano',
    },
  },
  vectorSpace: {
    fullTip: 'El Espacio Vectorial está lleno.',
    fullSolution: 'Actualiza tu plan para obtener más espacio.',
  },
  apps: {
    fullTipLine1: 'Actualiza tu plan para',
    fullTipLine2: 'crear más aplicaciones.',
    fullTip1des: 'Has alcanzado el límite de aplicaciones de construcción en este plan',
    fullTip2des: 'Se recomienda limpiar las aplicaciones inactivas para liberar espacio de uso, o contactarnos.',
    fullTip1: 'Actualiza para crear más aplicaciones',
    fullTip2: 'Límite de plan alcanzado',
    contactUs: 'Contáctanos',
  },
  annotatedResponse: {
    fullTipLine1: 'Actualiza tu plan para',
    fullTipLine2: 'anotar más conversaciones.',
    quotaTitle: 'Cuota de Respuesta Anotada',
  },
  usagePage: {
    buildApps: 'Construir aplicaciones',
    documentsUploadQuota: 'Cuota de carga de documentos',
    vectorSpace: 'Almacenamiento de Datos de Conocimiento',
    teamMembers: 'Miembros del equipo',
    annotationQuota: 'Cuota de anotación',
    vectorSpaceTooltip: 'Los documentos con el modo de indexación de alta calidad consumirán recursos de Almacenamiento de Datos de Conocimiento. Cuando el Almacenamiento de Datos de Conocimiento alcanza el límite, no se subirán nuevos documentos.',
  },
  teamMembers: 'Miembros del equipo',
}

export default translation
